/**
 * On-Page SEO brief, Part 3 — one canonical contact form serving both the
 * administrator and parent/community pathways via a `?role=` query param.
 *
 * - Pre-selects the "I'm a…" dropdown from `?role=` on load, when the field
 *   isn't already populated server-side (a failed submission re-renders the
 *   form with the previously-chosen value via Liquid; this script must not
 *   clobber that).
 * - Shows the "not the decision-maker?" note whenever Parent/Student/Other
 *   is selected, whether that came from the query param or a manual choice.
 */
(function () {
  var ROLE_PARAM_MAP = {
    parent: 'Parent or guardian',
    admin: 'School administrator',
    administrator: 'School administrator',
    student: 'Student',
    teacher: 'Teacher or staff',
    staff: 'Teacher or staff',
    pto: 'PTO / PTA / booster member',
    booster: 'PTO / PTA / booster member',
    other: 'Other',
  };

  var NON_DECISION_MAKER_ROLES = ['Parent or guardian', 'Student', 'Other'];

  function toggleNote(select, note) {
    if (!select || !note) return;
    var show = NON_DECISION_MAKER_ROLES.indexOf(select.value) !== -1;
    note.hidden = !show;
  }

  document.querySelectorAll('[data-contact-role-select]').forEach(function (select) {
    var form = select.closest('form');
    var note = form ? form.querySelector('[data-contact-role-note]') : null;

    // Only pre-select from the URL if the field doesn't already carry a
    // server-rendered value (a re-rendered form after a validation error
    // should keep whatever the visitor actually chose).
    if (!select.value) {
      var params = new URLSearchParams(window.location.search);
      var raw = (params.get('role') || '').toLowerCase();
      var mapped = ROLE_PARAM_MAP[raw];
      if (mapped) {
        select.value = mapped;
      }
    }

    toggleNote(select, note);
    select.addEventListener('change', function () {
      toggleNote(select, note);
    });
  });
})();
